<div class="modal-header">
    <h3>{{model.title}}</h3>
    <div class="modal-header__right">
        <button class="btn btn--close" type="button" aria-label="Sluiten" (click)="dismiss()">
            <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
        </button>
    </div>
</div>

<div class="modal-body">
    <p>{{model.body}}</p>
</div>

<div class="modal-footer">
    <div class="btn-group btn-group--spread">
        <button *ngIf="model.ontkenning !== null" class="btn btn--link" (click)="dismiss()">{{model.ontkenning}}</button>
        <button *ngIf="model.bevestiging !== null" class="btn btn--primary" (click)="close()">{{model.bevestiging}}</button>
    </div>
</div>
